import { useNavigate } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { MyExpensesDataCollection } from 'modules/expenses/components/my_expenses/DataCollection/MyExpensesDataCollection'
import { useExpensesListPage } from 'modules/expenses/hooks/useExpensesListPage'

const MyExpensesListTab = () => {
  const { employee } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { company } = useCurrentSession()

  const { canSeeTransactions, hasExpensesReportOnBehalfFeature, loading, recommendationsEnabled } =
    useExpensesListPage({ companyId: company.id, skipProjectsQuery: true })

  if (!employee) {
    navigate(navigation.myExpenses.list.expenses.fullPath())
    return null
  }

  if (loading) {
    return (
      <Box paddingY="s32" paddingX="s48" justifyContent="center" alignItems="center" width="full">
        <Spinner />
      </Box>
    )
  }

  return (
    <MyExpensesDataCollection
      companyId={company.id}
      employeeId={employee.id}
      back={{ href: navigation.myExpenses.list.expenses.fullPath() }}
      canSeeTransactions={canSeeTransactions}
      hasReportOnBehalfFeature={hasExpensesReportOnBehalfFeature}
      recommendationsEnabled={recommendationsEnabled}
    />
  )
}

export default MyExpensesListTab
